//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';

export default {
    name: "projectSelect",
    data() {
        return {
            processImg: require('@/assets/img/parking/cshy.jpg'),
            downloadUrl: util.ApiUrl + '/file/download/',
            list: []
        }
    },
    methods: {
        goToProject() {
            //this.$router.push({path: '/projectSale/'})
            window.location.href = "http://s.appykt.com/zld/qr/e?code=83447";
        },

    },
    created() {

    }
}
